// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3824":"css/app.7066","7239":"css/admin-app.7066"}[chunkId] + ".css";
};